import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import {
  VacanciesApiResponse,
  VacancyResponse,
} from "../types/vacancies-types";

export const fetchVacancies = createAsyncThunk(
  "vacancies/fetchVacancies",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<VacanciesApiResponse>(
        "/vacancies?populate=*"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type VacanciesState = {
  vacancies: VacancyResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: VacanciesState = {
  vacancies: [],
  status: "idle",
  error: null,
};

const vacanciesSlice = createSlice({
  name: "vacancies",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVacancies.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVacancies.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vacancies = action.payload.data;
      })
      .addCase(fetchVacancies.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default vacanciesSlice.reducer;
